import { useEffect, useState } from 'react';

const useEffectWindowSize = () => {
	const [size, setSize] = useState(0);
	useEffect(() => {
		let timeout_id;

		const updateSize = () => {
			clearTimeout(timeout_id);

			timeout_id = setTimeout(() => setSize(window.innerWidth), 150);
		};
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => {
			window.removeEventListener('resize', updateSize);
			clearTimeout(timeout_id);
		};
	}, []);
	return size;
};

export default useEffectWindowSize;
